module.exports = __webpack_public_path__ + "img/ukulelebg@2x.75b9d21a.png";